import type { ObservationCategoryModel } from "src/features/Admin/Observations/models";

import { Link } from "react-router-dom";
import { CategoryCard } from "src/features/observations/components/CategoryCard";

export type FormCategoriesListProps = {
	categories?: ObservationCategoryModel[];

	admin?: boolean;

	itemHref: (category: ObservationCategoryModel) => string;

	onCreateNewCategoryClick?: () => void;
};

const FormCategoriesList = ({
	categories,
	admin = false,
	itemHref,
	onCreateNewCategoryClick
}: FormCategoriesListProps) => {
	const shouldShowCardOptions = (category: ObservationCategoryModel) => {
		if (!admin) return false;

		if (category.name === "Undefined") return false;

		return true;
	};

	return (
		<div>
			{categories && categories.length > 0 && (
				<div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
					{categories.map((category) => (
						<Link to={itemHref?.(category)} key={category.id}>
							<CategoryCard
								name={category.name}
								publishedFormsCount={category.publishedFormsCount}
								draftFormsCount={category.draftFormsCount}
								onEditNewCategoryClick={onCreateNewCategoryClick}
								showCardOptions={shouldShowCardOptions(category)}
								id={category.id}
								admin={admin}
							/>
						</Link>
					))}
				</div>
			)}
		</div>
	);
};

export default FormCategoriesList;
